import { render, staticRenderFns } from "./AnswerUniqueTable.vue?vue&type=template&id=32a2779d&scoped=true&"
import script from "./AnswerUniqueTable.vue?vue&type=script&lang=js&"
export * from "./AnswerUniqueTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a2779d",
  null
  
)

export default component.exports